module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp1_9016.6faafa97.png";